module.exports = __webpack_public_path__ + "img/page.7da12bcf.png";